import { render, staticRenderFns } from "./people_involved.vue?vue&type=template&id=56511792&scoped=true&"
import script from "./people_involved.vue?vue&type=script&lang=js&"
export * from "./people_involved.vue?vue&type=script&lang=js&"
import style0 from "./people_involved.vue?vue&type=style&index=0&id=56511792&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56511792",
  null
  
)

export default component.exports